module.exports = __webpack_public_path__ + "img/9788996575542.582dc616.jpg";